module.exports = __webpack_public_path__ + "img/coeur_de_vignobles.98e6fcc2.jpg";